import {ActionsRow, layout, Loader, ScrollableCard} from 'mc/lib';
import {storeFromArea} from 'mc/lib/utils';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {CardBlock} from 'reactstrap';
import {fetchZadostIfNeeded, ZADOST_AREA} from '../actions/zadostActions';
import ZadostPlatbyCard from '../components/zadost/ZadostPlatbyCard';
import ZadostUdajeCard from '../components/zadost/ZadostUdajeCard';

class ZadostPage extends Component {

    componentDidMount() {
        this.fetchData(true);
    }

    componentDidUpdate() {
        this.fetchData(false);
    }

    fetchData(force) {
        const {match, dispatch} = this.props;
        const id = parseInt(match.params.id);
        if (id) {
            dispatch(fetchZadostIfNeeded(id, force));
        }
    }

    renderHeader() {
        return <div>
            <CardBlock>
                <ActionsRow>
                    <h1>Žádost</h1>
                </ActionsRow>
            </CardBlock>
        </div>;
    }

    render() {
        const {zadost} = this.props;
        if (zadost.isFetching) {
            return <Loader/>;
        }
        if (!zadost.fetched) {
            return null;
        }
        return (
            <div className="app-wrapper">
                <div className="app-wrapper-content">
                    <layout.PageWrapper>
                        <layout.PageContent fullWidth header={this.renderHeader()}>
                            <ScrollableCard detail>
                                <ZadostUdajeCard zadost={zadost.data}/>
                                <ZadostPlatbyCard zadost={zadost.data}/>
                            </ScrollableCard>
                        </layout.PageContent>
                    </layout.PageWrapper>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    zadost: storeFromArea(state, ZADOST_AREA),
});

export default connect(mapStateToProps)(ZadostPage);
